export const MIN_ELMERS_STORE_ID = 400;
export const MAX_ELMERS_STORE_ID = 499;
